import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98e10a40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-heart" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    onMousedown: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.likeAction && _ctx.likeAction(...args)), ["prevent"])),
    type: "button",
    class: "btn btn-love px-3 py-0 text-nowrap"
  }, [
    _hoisted_1,
    _createTextVNode(" Мне нравится ")
  ], 32))
}